import React from "react";

/**
 * Timer Component
 * Displays elapsed time in MM:SS format
 */
const Timer = ({ seconds = 0 }) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  const formatNumber = (num) => String(num).padStart(2, "0");

  // Color based on time spent
  const getColorClass = () => {
    if (seconds < 600) return "text-green-600 dark:text-green-400"; // < 10 min
    if (seconds < 1200) return "text-yellow-600 dark:text-yellow-400"; // < 20 min
    return "text-orange-600 dark:text-orange-400"; // >= 20 min
  };

  return (
    <div className="text-center">
      <div className={`text-2xl font-bold font-mono ${getColorClass()}`}>
        {formatNumber(minutes)}:{formatNumber(remainingSeconds)}
      </div>
      <div className="text-xs text-gray-600 dark:text-gray-400">Time Spent</div>
    </div>
  );
};

export default Timer;


